import ShortUniqueId from 'short-unique-id'
import { doc, getDoc, setDoc } from 'firebase/firestore'
import { firebase_firestore } from '../firebaseConfig'
import murmurhash from 'murmurhash'

export type LinkObject = {
  linkId: string
  id: string
  refPath: string
  type: 'PATTERN' | 'BACKTEST' | 'ALERT'
  viewCount: number
  createdAt: number
  name?: string
  createdBy?: { gcid?: string; email?: string }
  emailsInvited?: string[]
  gcidAccepted?: string[]
  gcidAcceptedMap?: Record<string, { email: string; acceptedAt: number }>
}

async function generateShareLink(
  id: string,
  refPath: string,
  type: LinkObject['type'],
  options?: { name?: string; duration?: number; createdBy?: { gcid?: string; email?: string } }
): Promise<LinkObject> {
  const uidGenerator = new ShortUniqueId()
  // @ts-ignore
  const uid = uidGenerator.randomUUID(5)
  const linkId = `${options?.createdBy?.gcid || uid}-${id}`
  const linkIdHash = murmurhash.v3(linkId).toString()

  const docRef = doc(firebase_firestore, `shareables/${linkIdHash}`)
  const existingDoc = await getDoc(docRef)
  if (existingDoc.exists()) {
    const existingLinkObject = existingDoc.data() as LinkObject
    return existingLinkObject
  } else {
    const linkObject = {
      linkId: linkIdHash,
      id,
      refPath: refPath,
      type,
      viewCount: 0,
      createdAt: new Date().getTime(),
      createdBy: options?.createdBy || {},
      name: options?.name || '',
    }

    await setDoc(doc(firebase_firestore, docRef.path), linkObject)
    return linkObject
  }
}

export default generateShareLink
